export const scrollPositionsByKey = new Map();
export const elementsCountByKey = new Map();
window.scrollPositionsByKey = scrollPositionsByKey;
window.elementsCountByKey = elementsCountByKey;
